import React, {useEffect, useState} from 'react';
import Home from "../home/Home";
import Dashboard from "../dashboard/Dashboard";
import {Col, Container, Row} from "react-bootstrap";
import Search from "./Search";
import Test from "../planet-sclae-data/Test";

export default function Content() {

    const [isDashboard, setIsDashboard] = useState(false);
    const [isTest, setIsTest] = useState(false);

    useEffect(() => {
        // TEST
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.get('page') && 'planet-scale-data' === urlParams.get('page')) {
            setIsTest(true);
        }
        // END - TEST


        detectArtistId();
        window.addEventListener('popstate', function (event) {
            detectArtistId();
        });

        function detectArtistId() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            if (urlParams.get('page') && 'dashboard' === urlParams.get('page')) {
                setIsDashboard(true);
            }
        }

    }, [])

    return (
        <>
            <Container fluid className="my-5 main-container">
                <Row>
                    <Col xs={12}>
                        <div className="introduction">
                            <h1>PcEn Dashboard</h1>
                            <h2>Le Dashboard qui vous dit tout sur la visibilité des artistes</h2>
                        </div>
                    </Col>
                    <Col lg={7} xl={8}>
                        <Search />
                    </Col>
                    {/* to uncomment for test */}
                    {/*{ isTest ?*/}
                    {/*    <Test /> :*/}
                    {/*    (isDashboard ? <Dashboard /> : <Home />)*/}
                    {/*}*/}
                    {isDashboard ? <Dashboard /> : <Home />}
                </Row>
            </Container>
        </>
    )
}